// The YouTube facades of the HTML rendered with v-html (articles, posts, comments, see utils/youtubeFacade.ts)
// carry no Vue handler: one listener on the document swaps the clicked facade for the real player.
export default defineNuxtPlugin((nuxtApp) => {
  // load/error do not bubble: listen in the capture phase, and check the thumbnails already loaded before the app
  const THUMB = 'img.yt-facade__thumb'
  const onThumb = (event: Event) => {
    const img = event.target as HTMLImageElement
    if (img?.matches?.(THUMB)) fallbackYoutubeThumbnail(img, event.type === 'error')
  }
  document.addEventListener('load', onThumb, true)
  document.addEventListener('error', onThumb, true)
  nuxtApp.hook('app:mounted', () => {
    document
      .querySelectorAll<HTMLImageElement>(THUMB)
      .forEach((img) => fallbackYoutubeThumbnail(img))
  })

  document.addEventListener('click', (event) => {
    const facade = (event.target as Element | null)?.closest?.<HTMLElement>(
      'button.yt-facade[data-yt-id]',
    )
    if (!facade) return

    const video = parseYoutubeEmbed(
      `https://www.youtube.com/embed/${facade.dataset.ytId}?${facade.dataset.ytParams ?? ''}`,
    )
    if (!video) return

    event.preventDefault()

    const iframe = document.createElement('iframe')
    iframe.src = youtubeAutoplayUrl(video.id, video.params)
    iframe.title = facade.getAttribute('aria-label') ?? 'Vidéo YouTube'
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    iframe.allowFullscreen = true
    iframe.referrerPolicy = 'strict-origin-when-cross-origin'
    iframe.setAttribute('frameborder', '0')

    const className = [...facade.classList]
      .filter((name) => name !== 'yt-facade')
      .join(' ')
    if (className) iframe.className = className

    const style = facade.getAttribute('style')
    if (style) iframe.setAttribute('style', style)

    facade.replaceWith(iframe)
  })
})
